import { render, staticRenderFns } from "./BasketAccordion.vue?vue&type=template&id=64c1be82&scoped=true&"
import script from "./BasketAccordion.vue?vue&type=script&lang=js&"
export * from "./BasketAccordion.vue?vue&type=script&lang=js&"
import style0 from "./BasketAccordion.vue?vue&type=style&index=0&id=64c1be82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c1be82",
  null
  
)

export default component.exports